/** @jsxImportSource @emotion/react */
import { switchStyle, switchTrackStyle } from './Switch.styles';

export interface SwitchProps {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

/** 켬/끔 토글. 모듈 enabled 설정에 활용. 상태는 바깥이 소유. */
export function Switch({ checked = false, disabled, onChange }: SwitchProps) {
  return (
    <label css={switchStyle(disabled)}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span css={switchTrackStyle(checked)} />
    </label>
  );
}
